import { createContext, useContext } from "react";
import { POInvoiceDetails } from "../types/POInvoiceDetails";
import { POInvoiceContextType } from "../types/POInvoiceContextType";


const POInvoiceContext = createContext<{
	invoice: POInvoiceContextType,
	modify: (invoice: POInvoiceDetails) => void
}>
	({
		invoice: {} as POInvoiceContextType,
		modify: () => { }
	});

const usePOInvoice = () => useContext(POInvoiceContext);

export { POInvoiceContext, usePOInvoice }
